import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import HeroBanner from './components/HeroBanner';
import WhyNeedSection from './components/WhyNeedSection';
import OurServicesSection from './components/OurServicesSection';
import HowWeWorkSection from './components/HowWeWorkSection';
import TrademarkSearchSection from './components/TrademarkSearchSection';
import WhoNeedsSection from './components/WhoNeedsSection';
import AmazonRegistrySection from './components/AmazonRegistrySection';
import WhyChooseUsSection from './components/WhyChooseUsSection';
import PricingSection from './components/PricingSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import FinalCTASection from './components/FinalCTASection';
import Footer from './components/Footer';
import ContactFormDialog from './components/ContactFormDialog';
import { Toaster } from './components/ui/toaster';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import { Navigate } from 'react-router-dom';

function HomePage() {
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);
  const open = () => setIsContactFormOpen(true);

  return (
    <div>
      <Header onOpenContactForm={open} />
      <HeroBanner onOpenContactForm={open} />
      <WhyNeedSection />
      <OurServicesSection onOpenContactForm={open} />
      <HowWeWorkSection />
      <TrademarkSearchSection onOpenContactForm={open} />
      <WhoNeedsSection />
      <AmazonRegistrySection onOpenContactForm={open} />
      <WhyChooseUsSection />
      <PricingSection onOpenContactForm={open} />
      <TestimonialsSection />
      <FAQSection />
      <FinalCTASection onOpenContactForm={open} />
      <Footer onOpenContactForm={open} />
      <ContactFormDialog isOpen={isContactFormOpen} onClose={() => setIsContactFormOpen(false)} />
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
